export function isVersicherungssumeLowerOrEqual500000(versicherungssumme: number): boolean {
  return versicherungssumme <= 500000;
}

export function isVersicherungssumeGreaterThan500000(versicherungssumme: number): boolean {
  return versicherungssumme > 500000;
}

export function isWertsachenValueDefault(
  wertsachenValue: number,
  versicherungssumme: number,
): boolean {
  return Math.abs(wertsachenValue / versicherungssumme - 0.4) < Number.EPSILON;
}

export function isWertsachenValueGreaterThan100000(wertsachenValue: number): boolean {
  return wertsachenValue > 100000;
}
